import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";

export default function LoginScreen() {
  const { instance } = useMsal();

  function handleLogin() {
    instance.loginRedirect(loginRequest);
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="w-full max-w-sm text-center">
        <h1 className="text-3xl font-semibold text-[#1B3A5C] tracking-tight mb-2">
          Sandeu DLS
        </h1>
        <p className="text-sm text-slate-500 mb-8">
          Digital Life System — Home Portal
        </p>
        <button
          onClick={handleLogin}
          className="w-full bg-[#1B3A5C] hover:bg-[#0E243B] text-white font-medium py-3 px-4 rounded-xl transition-colors text-base"
        >
          Sign in with Microsoft
        </button>
        <p className="text-xs text-slate-400 mt-4">
          Sandeu family accounts only
        </p>
      </div>
    </div>
  );
}
